import { Component, input, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'app-menu-heading-cabinet',
    templateUrl: './menu-heading.component.html',
    styleUrl: './menu-heading.component.scss',
    encapsulation: ViewEncapsulation.ShadowDom
})
export class MenuHeadingCabinetComponent {
    isCollapsed = input(false);
}
